import { endpoints, host } from '@config/endpoints';
import request from './request';

export const exportMostRequiredJobInfo = async (urlDataAPI:any) => {
    const { exportType, mostRequiredJobsTitle, hubIds, sectorIds, occupationCategoryIds, Isco4Ids, locations, fromTimeline, toTimeline, isEntryLevel} = urlDataAPI;
    const { path, method } = endpoints.occupationAndSector.exportMostRequiredJobInfo;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { exportType, ExportTitle:mostRequiredJobsTitle, hubIds, ISICCodes:sectorIds, ISCO2Codes:occupationCategoryIds, ISCO4Codes:Isco4Ids, locations, fromQuarter: fromTimeline, toQuarter: toTimeline, isEntryLevel },
            {
                responseType: "blob"
            },
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};